module.exports = "<div class=\"gw-media-sidebar\">\n    <div class=\"gw-sidebar-content\"></div>\n</div>"